/** Blend a hex colour toward white by `amount` (0 = white, 1 = full colour). */
export function hexTintOnWhite(hex: string, amount: number): string {
    if (!/^#[0-9a-fA-F]{6}$/.test(hex)) return `rgba(255,255,255,${amount})`;
    const r = Number.parseInt(hex.slice(1, 3), 16);
    const g = Number.parseInt(hex.slice(3, 5), 16);
    const b = Number.parseInt(hex.slice(5, 7), 16);
    const mr = Math.round(255 * (1 - amount) + r * amount);
    const mg = Math.round(255 * (1 - amount) + g * amount);
    const mb = Math.round(255 * (1 - amount) + b * amount);
    return `rgb(${mr}, ${mg}, ${mb})`;
}
